export const environment = {
  production: true,
  logoUrl: '/Areas/ImisIntelligence/assets/logo.png',
  imis: {
    baseUrl: '',
    username: '',
    password: '',
    iqaQueryName: '$/_i4u_/SandBox/Hubert/All Members Report',
    contactLookupQueryName: '$/_i4u_/SandBox/Hubert/Contact Lookup',
    worksiteLookupQueryName: '$/_i4u_/SandBox/Hubert/Lookup Worksite'
  },
  anthropic: {
    apiKey: '',
    model: 'claude-haiku-4-5'
  }
};
